import { RenderStudyArea } from "components/map/layers/RenderStudyArea";
import { RenderMeasureConfigs } from "components/measures/addMeasurePage/RenderMeasureConfigs";
import { useMap } from "react-leaflet";
import { MeasureConf, StudyArea } from "types/types";

interface Props {
  studyArea: StudyArea;
  measureConfigs: MeasureConf[];
}

export function DrawResult(props: Props) {
  const { studyArea, measureConfigs } = props;
  const map = useMap();
  return (
    <>
      <RenderStudyArea mapRef={map} studyAreaGeo={studyArea.geometry_4326} />
      <RenderMeasureConfigs mapRef={map} measureConfigs={measureConfigs} />
    </>
  );
}
